/*=========================================================================================
  File Name: moduleTheoryRatingEnglish.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleTheoryRatingEnglishState.js'
import mutations from './moduleTheoryRatingEnglishMutations.js'
import actions from './moduleTheoryRatingEnglishActions.js'
import getters from './moduleTheoryRatingEnglishGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  //mutations: mutations,
  actions: actions,
  getters: getters
}

